export const ON_DEMAND_PATH = '/beamonscreen/ods';

export type OnDemandKind = 'video' | 'audio' | 'reels';
export type OnDemandItemType = 'video' | 'audio' | 'reel';
export type OnDemandStatus = 'queued' | 'playing' | 'played' | 'cancelled';

export interface OnDemandItem {
    type: OnDemandItemType;
    assetId: string | null;
    url: string;
    name: string;
    mimeType: string;
    reelId: string | null;
    version: number | null;
    durationMs: number;
}

export interface OnDemandPlaylist {
    _id: string;
    companyId: string;
    userId: string;
    screenId: string;
    userFirstName: string;
    userLastName: string;
    userEmail: string;
    name: string;
    kind: OnDemandKind;
    items: OnDemandItem[];
    totalDurationMs: number;
    status: OnDemandStatus;
    maxPlays: number;
    playCount: number;
    createdAt: string;
    updatedAt: string;
}

export interface OnDemandItemInput {
    type: OnDemandItemType;
    assetId?: string;
    reelId?: string;
    version?: number;
    name?: string;
    mimeType?: string;
    durationMs?: number;
}

export interface CreateOnDemandPlaylistPayload {
    name: string;
    kind: OnDemandKind;
    maxPlays: number;
    items: OnDemandItemInput[];
}

export const ON_DEMAND_KIND_LABEL: Record<OnDemandKind, string> = {
    video: 'Video',
    audio: 'Audio',
    reels: 'Reels',
};

export const createdByLabel = (playlist: Pick<OnDemandPlaylist, 'userFirstName' | 'userLastName' | 'userEmail'>): string => {
    const name = [playlist.userFirstName, playlist.userLastName].map((part) => (part || '').trim()).filter(Boolean).join(' ');
    return name || playlist.userEmail || 'Unknown';
};
